import React from 'react'
import SortingVisualiser from './SortingVisualiser/SortingVisualiser'
import './style.scss'

export default function App() {
  return (
    <div>
      <SortingVisualiser />
    </div>
  )
}
